export default __webpack_public_path__ + "static/media/lateral2.7aa8ba67.svg";